export default __webpack_public_path__ + "static/media/PrintRuleBackSideDoorHanger.93b4b6dd.jpg";